import Media from './../mediaDetect.js'; //Детектор медиа

let Subsidiaries = {
    openPopup: function(preview){

        let content = preview.closest('[data-content-subsidiaries]'),
            item = preview.closest('[data-item-subsidiaries]'),
            detail = item.find('[data-detail-item-subsidiaries]'),
            popup = $('[data-subsidiaries-popup]'),
            contentPopup = popup.find('[data-content-subsidiaries-popup]');

        // Внутрь попапа добавляем детальное описание предприятия
        contentPopup.html(detail.html());
        popup.addClass('show');

        var heightContentPopup = contentPopup.outerHeight();

        if(Media.detect().isMobile) {
            popup.height(heightContentPopup);
        }else{
            (heightContentPopup > 500) ? popup.height(500) : popup.height(heightContentPopup);
        }

        $('.nano').nanoScroller();

        var topPositionPopup = 0,
            heightContent = content.height(),
            heightPopup = popup.outerHeight(),
            itemTopPosition = item.position().top;

        // Если попап длиннее контентного блока, то выравниваем по верхнему краю
        if(heightContent < heightPopup) {
            topPositionPopup = 0;
        }else {
            // Если высота контента меньше высоты попапа с отступом от верхнего края, то выравниваем по нижнему краю контента
            // В противном случае задаём попапу отступ от верхнего края контента такой же, как у элемента, на который мы нажали
            if(heightContent < itemTopPosition + heightPopup) {
                topPositionPopup = heightContent - heightPopup;
            }else {
                topPositionPopup = itemTopPosition;
            }
        }
        
        popup.css('top', topPositionPopup + 'px');
    },
    closePopup: function(btn){
        let popup = btn.closest('[data-subsidiaries-popup]'),
            contentPopup = popup.find('[data-content-subsidiaries-popup]');

        popup.removeClass('show');
        contentPopup.html('');
    }
}

$(document).ready(function($) {
    let previewSubsidiaries = $('[data-preview-item-subsidiaries]');
    if(previewSubsidiaries.length) {

        previewSubsidiaries.on('click', function(e){
            e.preventDefault();
            Subsidiaries.openPopup($(this));         
        });
    }

    let btnCloseSubsidiaries = $('[data-btn-close-subsidiaries-popup]');
    if(btnCloseSubsidiaries.length) {

        btnCloseSubsidiaries.on('click', function(e){
            e.preventDefault();
            Subsidiaries.closePopup($(this));         
        });
    }
    
});


// WEBPACK FOOTER //
// ./components/subsidiaries.js